// extracted by mini-css-extract-plugin
export default {"container":"ZKnKR","rightSide":"zhGGd","old":"HAiqp"};